@if (showError) {
  <div class="error" @rollUp>
    <ng-content></ng-content>
  </div>
}
